

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import preguntas from './resumen-preguntas-ml-preguntas.vue';
    import contestar from './resumen-preguntas-ml-contestar.vue';
    import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
    import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            preguntas,
            contestar
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Controlador.Pedido.Cliente; }
        public get Envio() { return this.Controlador.Pedido.Envio; }


        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {

        }

        Cerrar()
        {
            this.Abierto = false;
        }

        public Cargando: boolean = false;
        public Preguntas: Pregunta[] = [];

        async mounted()
        {
            this.Cargando = true;
            await Wait( 4000 );
            this.Preguntas.clear();
            this.Preguntas = await this.Pedido.CargarPreguntas();
            this.Cargando = false;
        }


    }
